// Dependencies
import React from 'react';
import { ThemeContext } from '../theme/Theme.jsx';
import radium from 'radium';
import moment from 'moment';
import { connect } from 'react-redux';
import RadioSelection from '../radioSelection/RadioSelection.tsx';
import SectionTitle from '../../components/sectionTitle/SectionTitle.jsx';
import Section from '../../components/section/Section.jsx';
import shipmentTypesEnum from './shipment-types-enum.js';
import LeoPopup from '../../components/popup/LeoPopup.jsx';
import ZigZagBox from '../../components/zig-zag-box/ZigZagBox.jsx';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ShipmentType(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		list: {
			margin: '1em 0 0',
		},
		labelAdditional: {
			fontSize: context.themeManager.value('shipment-label-additional',
				'fontSize', 'font-size-80'),
			lineHeight: context.themeManager.value('shipment-label-additional',
				'lineHeight', 'line-height-200'),
		},
	};

	function createShipmentTypeLabel(shipmentType, shipmentFee, availability) {
		return (
			<div>
				{shipmentType} {shipmentFee && `(${shipmentFee} €)`}
				<div style={style.labelAdditional}>{availability}</div>
			</div>
		);
	}

	const allUnavailable = props.shipmentTypes.length < 1;

	return (
		<Section error={props.errors.length > 0}>
			<SectionTitle id={"shipment_label"} headlineLevel={"h2"}>Bitte wählen Sie Ihre Versandart</SectionTitle>
			{!allUnavailable &&
				<ul style={style.list} role="radiogroup" aria-labelledby={"shipment_label"} id={"shipment_selection"}>
					{props.shipmentTypes.map((st, i) => {
						const shipmentFee = props.shipmentFees[st] ? props.shipmentFees[st].money.value.toFixed(2) : null;
						const availabilityInHours = props.availabilityInHours[st];
						const availableUntil = moment(props.eventBegin).subtract(availabilityInHours, 'hours');
						const expired = moment() > availableUntil;
						const disabledShipmentTypeInfos = props.disabledShipmentTypes.find(dSt => dSt.shipmentType === st);
						const disabled = !!disabledShipmentTypeInfos;
						const eventTitle = ((expired || disabled) && disabledShipmentTypeInfos) ? disabledShipmentTypeInfos.eventInfo[0].title : '';
						const availabilityPart = expired || disabled ?
							`Bei mindestens einer Veranstaltung ist diese Versandart nicht verfügbar oder der Termin ist zu kurzfristig.
							(${eventTitle})` :
							`verfügbar bis ${moment(availableUntil).format('DD.MM.YYYY HH:mm')}`;

						const label = createShipmentTypeLabel(shipmentTypesEnum[st],
							shipmentFee, availabilityPart);
						return (
							<ShipmentTypeListItem
								key={i}
								onChange={props.onChange}
								radioGroupValue={props.selectedShipmentType}
								value={st}
								label={label}
								disabled={disabled || expired}
								expired={expired}
							/>
						);
					}
					)}
				</ul>
			}
			{allUnavailable &&
				<ZigZagBox>Leider ist keine Versandart für diese Veranstaltung verfügbar</ZigZagBox>
			}
		</Section>
	);
}

const RadiumShipmentType = radium(ShipmentType);

class ShipmentTypeListItem extends React.Component {

	constructor(props, context) {
		super(props);

		this.state = {
			showPopup: false,
		};

		this.togglePopup = this.togglePopup.bind(this);

		this.style = {
			listItem: {
				display: 'flex',
				justifyContent: 'space-between',
				paddingRight: '0.5em',
				whiteSpace: 'pre-line',
			},
			labelInfoIcon: {
				color: context.themeManager.value('shipment-label-icon',
					'color', 'fg-color-icon-highlight'),
				fontSize: context.themeManager.value('shipment-label-icon',
					'fontSize', 'font-size-400'),
			},
		};
	}

	togglePopup() {
		this.setState({
			showPopup: !this.state.showPopup,
		});
	}

	render() {
		const shipmentTypeDisplay = shipmentTypesEnum[this.props.value];

		return (
			<li key={this.props.key} style={this.style.listItem}>
				<RadioSelection
					name="shipmentType"
					value={this.props.value}
					onChange={this.props.onChange}
					radioGroupValue={this.props.radioGroupValue}
					label={this.props.label}
					disabled={this.props.disabled}
				/>
				<button
					tabIndex={this.props.radioGroupValue == this.props.value ? 0 : -1 }
					className={"leo__button-sample"}
					onClick={() => this.togglePopup()}
					title={"Informationen zur Versandart " + shipmentTypeDisplay}>
				<FontAwesomeIcon
					icon="fa-solid fa-circle-info"
					style={this.style.labelInfoIcon}
				/>
				</button>
				{this.state.showPopup &&
					<LeoPopup
						headline={shipmentTypeDisplay}
						onClose={() => this.togglePopup()}
					>
						{this.context.themeManager.getThemeText(shipmentTypeDisplay.toLowerCase())}
					</LeoPopup>
				}
			</li>
		);
	}
}

ShipmentTypeListItem.contextType = ThemeContext;

// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state, ownProps) => ({
	selectedShipmentType: ownProps.selectedShipmentType,
	onChange: ownProps.shipmentTypeChange,
	errors: state.eventPage.errors.filter(it => it.startsWith('shipmenttype_'))
	.map(it => it.replace('shipmenttype_', '')),
});

const mapDispatchToProps = () => ({
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RadiumShipmentType);
